import { ProcessTrackerSideNavigationTree } from './process-tracker-sidenav-tree';

export class MyWorkSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'MP_COMMUNITY_MANAGEMENT',
            path: null,
            icon: '',
            text: 'Community Management',
            tooltip: 'Community Management',
            items: MyWorkSideNavigationTree.topCMItems(`${parentId}_1`)
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_ON_BOARDING',
            path: null,
            icon: '',
            text: 'Community On-Boarding',
            tooltip: 'Community On-Boarding',
            items: MyWorkSideNavigationTree.topOnBoardingItems(`${parentId}_2`)
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'MP_PAYABLE_WF',
            path: null,
            icon: '',
            text: 'Payables Workflow',
            tooltip: 'Payables Workflow',
            items: MyWorkSideNavigationTree.topWFItems(`${parentId}_3`)
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'MP_RECEIVABLES_LB',
            path: null,
            icon: '',
            text: 'Receivables Lockbox',
            tooltip: 'Receivables Lockbox',
            items: MyWorkSideNavigationTree.topRLItems(`${parentId}_4`)
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'MP_DISCLOSURE_PROC',
            path: null,
            icon: '',
            text: 'Disclosure Processing',
            tooltip: 'Disclosure Processing',
            items: MyWorkSideNavigationTree.topDPItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'PROJECTS_TASKS',
            path: '/my-work/projects-tasks',
            icon: '',
            text: 'Projects / Tasks',
            tooltip: 'Projects / Tasks',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'INTERNAL_TASKS',
            path: '/my-work/internal-tasks',
            icon: '',
            text: 'Internal Tasks',
            tooltip: 'Internal Tasks',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'MYWORK_INBOX',
            path: '/my-work/mywork-inbox',
            icon: '',
            text: 'My Work Inbox',
            tooltip: 'My Work Inbox',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'PROCESS_TRACKER',
            path: null,
            icon: '',
            text: 'Process Tracker',
            tooltip: 'Process Tracker',
            items: ProcessTrackerSideNavigationTree.topItems(`${parentId}_9`)
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'PRINT_STATEMENT',
            path: '/my-work/print-statement',
            icon: '',
            text: 'Print Statement',
            tooltip: 'Print Statement',
            items: []
        }
    ];

    static topOnBoardingItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'COMMUNITY_SCHEDULE_FIRST_ASSESSMENT',
            path: '/my-work/community-on-boarding/first-assessment',
            icon: '',
            text: 'Schedule First Assessment',
            tooltip: 'Schedule First Assessment',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_SCHEDULE_INITIAL_STATEMENTS',
            path: '/my-work/community-on-boarding/initial-statement',
            icon: '',
            text: 'Schedule Initial Statement',
            tooltip: 'Schedule Initial Statement',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'TRANSITION_CHECKLIST',
            path: '/my-work/transition-checklist',
            icon: '',
            text: 'On-Boarding Checklist',
            tooltip: 'On-Boarding Checklist',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'ADD_COMMUNITY',
            path: '/my-work/add-community',
            icon: '',
            text: 'Add Community',
            tooltip: 'Add Community',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'ON_BOARDING_FLAGS',
            path: '/my-work/on-boarding-flags',
            icon: '',
            text: 'On-Boarding Flags',
            tooltip: 'On-Boarding Flags',
            items: []
        }
    ];

    static topCMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'ARCHITECTURAL_APPLICATION',
            path: '/my-work/architectural-application',
            icon: '',
            text: 'Architectural Application',
            tooltip: 'Architectural Application',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMON_LOTS_APPRAISAL',
            path: '/my-work/common-lots/appraisal',
            icon: '',
            text: 'Common Lots Appraisal',
            tooltip: 'Common Lots Appraisal',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'FULFILLMENT_QUEUE',
            path: '/my-work/fulfillment-queue',
            icon: '',
            text: 'Fulfillment Queue',
            tooltip: 'Fulfillment Queue',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'MAINTENANCE_WORK_ORDERS',
            path: '/my-work/workorder',
            icon: '',
            text: 'Maintenance Work Orders',
            tooltip: 'Maintenance Work Orders',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'VIOLATION_REVIEW',
            path: '/my-work/violation-review',
            icon: '',
            text: 'Violation Review',
            tooltip: 'Open Violations Requiring Review',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'AUTOMATED_DOCUMENT_PRINT',
            path: '/my-work/automated-print-document',
            icon: '',
            text: 'Automated Document Print',
            tooltip: 'Automated Document Print',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'PORTFOLIO_BOARD_APPROVALS',
            path: '/my-work/board-approval',
            icon: '',
            text: 'Board Approvals',
            tooltip: 'Board Approvals',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'WELCOME_LETTER_QUEUE',
            path: '/my-work/letter-queue',
            icon: '',
            text: 'Welcome Letter Queue',
            tooltip: 'Welcome Letter Queue',
            items: []
        }
    ];

    static topWFItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'WORKQUEUE',
            path: '/workflow/workqueue',
            icon: '',
            text: 'Invoice Approval',
            tooltip: 'Invoice Approval',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'WF_AAP_METRICS',
            path: '/workflow/metrics',
            icon: '',
            text: 'Metrics',
            tooltip: 'Metrics',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROCESS_WORKFLOW',
            path: '/workflow/editor',
            icon: '',
            text: 'Process Invoices',
            tooltip: 'Process Invoices',
            items: []
        }
    ];

    static topRLItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'STATEMENT_APPROVAL_QUEUE',
            path: '/my-work/statement-approval-queue',
            icon: '',
            text: 'Statement Approvals',
            tooltip: 'Statement Approvals',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'ORDER_ANNUAL_COUPONS',
            path: '/my-work/order-annual-coupons',
            icon: '',
            text: 'Order Annual Coupons',
            tooltip: 'Order Annual Coupons',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'BANK_RETURNS',
            path: '/my-work/bank-returns',
            icon: '',
            text: 'Bank Returns',
            tooltip: 'Bank Returns',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'PAYMENT_POST_ERRORS',
            path: '/my-work/payment-post-errors',
            icon: '',
            text: 'Payment Post Errors',
            tooltip: 'Payment Post Errors',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'NOC_QUEUE',
            path: '/my-work/noc-queue',
            icon: '',
            text: 'NOC Queue',
            tooltip: 'Notification of Change Queue',
            items: []
        }
    ];

    static topDPItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CLOSING_REQUESTS',
            path: '/my-work/closing-requests',
            icon: '',
            text: 'Closing Requests',
            tooltip: 'Closing Requests',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_BLOCKS',
            path: '/my-work/community-blocks',
            icon: '',
            text: 'Community Blocks',
            tooltip: 'Community Blocks',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROPERTY_CONVEYANCE',
            path: '/my-work/property-conveyance',
            icon: '',
            text: 'Property Conveyances',
            tooltip: 'Property Conveyances',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'LOCATION_MANAGER',
            path: '/my-work/location-manager',
            icon: '',
            text: 'Closing Portal Location Manager',
            tooltip: 'Closing Portal Location Manager',
            items: []
        }
    ];

    static communityItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'MP_COMMUNITY_MANAGEMENT',
            path: null,
            icon: '',
            text: 'Community Management',
            tooltip: 'Community Management',
            items: MyWorkSideNavigationTree.communityCMItems(`${parentId}_1`)
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'COMMUNITY_ON_BOARDING',
            path: null,
            icon: '',
            text: 'Community On-Boarding',
            tooltip: 'Community On-Boarding',
            items: [
                {
                    id: `${parentId}_2_1`,
                    parentId,
                    name: 'ON_BOARDING_FLAGS',
                    path: '/community/:communityId/my-work/on-boarding-flags',
                    icon: '',
                    text: 'On-Boarding Flags',
                    tooltip: 'On-Boarding Flags',
                    items: []
                },
                {
                    id: `${parentId}_2_2`,
                    parentId,
                    name: 'TRANSITION_CHECKLIST',
                    path: '/community/:communityId/my-work/transition-checklist',
                    icon: '',
                    text: 'On-Boarding Checklist',
                    tooltip: 'On-Boarding Checklist',
                    items: []
                }
            ]
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROJECTS_TASKS',
            path: '/community/:communityId/my-work/projects-tasks',
            icon: '',
            text: 'Projects / Tasks',
            tooltip: 'Projects / Tasks',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'INTERNAL_TASKS',
            path: '/community/:communityId/my-work/internal-tasks',
            icon: '',
            text: 'Internal Tasks',
            tooltip: 'Internal Tasks',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'PROCESS_TRACKER',
            path: null,
            icon: '',
            text: 'Process Tracker',
            tooltip: 'Process Tracker',
            items: ProcessTrackerSideNavigationTree.communityItems(`${parentId}_5`)
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'MYWORK_INBOX',
            path: '/community/:communityId/my-work/mywork-inbox',
            icon: '',
            text: 'My Work Inbox',
            tooltip: 'My Work Inbox',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'PRINT_STATEMENT',
            path: '/my-work/print-statement',
            icon: '',
            text: 'Print Statement',
            tooltip: 'Print Statement',
            items: []
        }
    ];

    static communityCMItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'MAINTENANCE_WORK_ORDERS',
            path: '/community/:communityId/my-work/workorder',
            icon: '',
            text: 'Maintenance Work Orders',
            tooltip: 'Maintenance Work Orders',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'BOARD_APPROVALS',
            path: '/community/:communityId/my-work/board-approval',
            icon: '',
            text: 'Board Approvals',
            tooltip: 'Board Approvals',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'ARCHITECTURAL_APPLICATION',
            path: '/community/:communityId/my-work/architectural-application',
            icon: '',
            text: 'Architectural Application',
            tooltip: 'Architectural Application',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'VIOLATION_REVIEW',
            path: '/community/:communityId/my-work/violation-review',
            icon: '',
            text: 'Violation Review',
            tooltip: 'Open Violations Requiring Review',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'WELCOME_LETTER_QUEUE',
            path: '/community/:communityId/my-work/letter-queue',
            icon: '',
            text: 'Welcome Letter Queue',
            tooltip: 'Welcome Letter Queue',
            items: []
        }
    ];
}
